var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import ThemeContext from '../../context/theme-context';
import { getMinimumHeight, getMinimumWidth } from '../../helpers/styles';
import WidgetType from './widgetType';
var assignKeysToChildWidgets = function (props) {
    var childWidgets = props.childWidgets;
    return childWidgets.length > 0
        ? childWidgets.map(function (widget) {
            return __assign(__assign({}, widget), { key: widget.identifier ||
                    widget.id ||
                    widget.attributes.name ||
                    uuidv4() });
        })
        : [];
};
var Widget = function (props) {
    var context = useContext(ThemeContext);
    var windowTheme = context;
    var childWidgetsWithKeys = assignKeysToChildWidgets(props);
    var type = props.type, identifier = props.identifier, childWidgets = props.childWidgets, attributes = props.attributes, sortIndex = props.sortIndex, parentWidget = props.parentWidget, windowId = props.windowId, restProps = __rest(props, ["type", "identifier", "childWidgets", "attributes", "sortIndex", "parentWidget", "windowId"]), widgetProps = __assign({ type: type,
        identifier: identifier,
        childWidgets: childWidgets,
        attributes: attributes,
        parentWidget: parentWidget }, restProps);
    return (React.createElement(WidgetType, __assign({}, widgetProps, { windowId: windowId, windowTheme: windowTheme }), childWidgetsWithKeys.map(function (_a) {
        var key = _a.key, widget = __rest(_a, ["key"]);
        return (React.createElement(StyledWidget, __assign({}, restProps, widget, { key: key, parentWidget: props, windowId: windowId, widgetId: key, windowTheme: windowTheme })));
    })));
};
var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + ";\n  min-width: " + getMinimumWidth(minimumSize) + ";";
};
var StyledWidget = styled(Widget)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ",
    ";\n  ",
    ";\n  ",
    ";\n"])), function (_a) {
    var attributes = _a.attributes;
    return attributes &&
        attributes.minimumSize &&
        getMinHeightWidth(attributes.minimumSize);
}, function (_a) {
    var attributes = _a.attributes, windowTheme = _a.windowTheme;
    return "\n        " + (attributes && attributes.font
        ? "\n            font-family: \"" + attributes.font.family + "\", " + windowTheme.window.fontFamily + "; \n            font-weight: " + (attributes.font.bold ? 'bold' : '') + "; \n        "
        : '') + "\n    ";
}, function (_a) {
    var attributes = _a.attributes;
    return "\n        " + (attributes &&
        attributes.backgroundImage &&
        "background-image:\n          url(" + require("../../assets/icons/" + attributes.backgroundImage.replace(/:/g, '') + ".png") + ");\n  \n    background-repeat: no-repeat;\n    background-size: 100% 100%;") + "\n    ";
});
Widget.propTypes = {
    type: PropTypes.string,
    identifier: PropTypes.string,
    attributes: PropTypes.object,
    childWidgets: PropTypes.array,
    parentWidget: PropTypes.object,
    dataItems: PropTypes.object,
};
Widget.defaultProps = {
    attributes: {},
    childWidgets: [],
    parentWidget: {},
    dataItems: {},
};
export default Widget;
var templateObject_1;
//# sourceMappingURL=index.js.map